/**
 * 저장용량 막대 (2026-08-21) — 좌측 맨 아래.
 *
 * ★ 이름을 정확히 쓴다. 서버에 **메일 전용 용량은 없다** — 메일 첨부는 개인 워크스페이스
 *   용량을 깎으므로, 여기 보이는 값은 `내 저장용량(메일 첨부 포함)` 이다.
 *   "메일 저장용량" 이라고 적으면 다른 수치인 줄 알게 된다.
 * ★ 못 받아 오면 **아무것도 그리지 않는다**. 빈 막대는 "용량이 0" 으로 읽힌다.
 */

import { useEffect, useState } from 'react';
import { getStorageBreakdown, type StorageUsage } from '../../api/workspace';
import { tMail } from '../../lib/mail-i18n';

function fmt(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let v = bytes;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i += 1; }
  return `${v >= 100 || i === 0 ? Math.round(v) : v.toFixed(1)} ${units[i]}`;
}

export function MailQuotaBar() {
  const [usage, setUsage] = useState<StorageUsage | null>(null);

  useEffect(() => {
    let cancelled = false;
    getStorageBreakdown()
      .then((res) => { if (!cancelled) setUsage(res?.usage ?? null); })
      .catch(() => { /* 못 받아 오면 안 그린다 — 빈 막대는 "0" 으로 읽힌다 */ });
    return () => { cancelled = true; };
  }, []);

  if (!usage) return null;

  const pct = usage.unlimited ? 0 : Math.min(100, Math.max(0, usage.pct));
  return (
    <div className="mail-quota">
      <div className="mail-quota-row">
        <span>{tMail('mail.quota.label')}</span>
        <span className="mail-quota-v">
          {usage.unlimited
            ? fmt(usage.usedBytes)
            : `${fmt(usage.usedBytes)} / ${fmt(usage.limitBytes)}`}
        </span>
      </div>
      {!usage.unlimited && (
        <div className="mail-quota-bar">
          <i style={{ width: `${pct}%` }} className={usage.warn ? 'is-warn' : undefined} />
        </div>
      )}
    </div>
  );
}
